import React from 'react'
import { Button } from '@/components/ui/button'
import store from '../../../state/store'

class ClaimButton extends React.Component {

  onClick = (e) => {
    e.stopPropagation()
    store.emit('enquiry:claim', this.props.enquiry_id)
  }

  render() {
    return (
      <div>
        {this.props.sales_manager ?
          <Button variant="success" className="m-[1%] h-[60px] w-[98%] text-[20px] font-bold" onClick={this.onClick}>Claim Enquiry from {this.props.sales_manager.name}</Button>
        :
          <Button variant="success" className="m-[1%] h-[60px] w-[98%] text-[20px] font-bold" onClick={this.onClick}>Claim Enquiry</Button>
        }
      </div>
    )
  }
}

export default ClaimButton
